<template>
	<div class="row mx-0 vue-cart-type-radio" :id="id" ref="radioPicker">
		<div
			v-for="(option, index) in options"
			:key="option.id"
      class=" radio-thumb"
			:class="{
				'disabled-option': !option.stock,
				'last-in-row': (index + 1) % 4 == 0,
				'option-active': value && option.id === value.id
			}"
			:data-id="option.id"
			ref="radioItems"
			@click="$emit('input', option)"
		>
			<div class="row mx-0 radio-content size-content">
				<label :for="option.id" class="size">
					{{ option.description }}
				</label>
				<input
					type="radio"
					:id="option.id"
					name="size"
					:value="typeof value !== 'undefined' && value !== null ? value.id : null"
					:checked="
						typeof value !== 'undefined' && value !== null ? option.id === value.id : false
					"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Radio",
	components: {},
	props: {
      id: {
          type: String,
          default: 'radioPicker',
      },
      options: Array, // array de objectos,
      value: Object,
      itemIndex: { // for multiple widgets
          type: Number,
          default: 0,
      },
	},

	computed: {},
	methods: {},
	watch: {
		// options: function(newValue, oldValue) {
		// 	if (oldValue !== newValue) {
		// 		this.selectedItem = null;
		// 	}
		// }
	},
	// TO FIX - THIS LOGIC MUST BE BETTER
	// deactivated() {
	// 	this.selectedItem = null;
	// },
	mounted() {
		/*this.$refs.radioPicker.addEventListener(
                "click",
                this.setSelectedItem
            );*/
	}
};
</script>

<style lang="scss" />
